import { atom } from '@reatom/framework'

import { PlatformUtil } from '../platform-util'

export const platformUtilAtom = atom(PlatformUtil, 'platformUtilAtom')

export const isTauriAtom = atom(
  (ctx) => ctx.spy(platformUtilAtom).is('tauri'),
  'isTauriAtom',
)

export const isBrowserLocalAtom = atom(
  (ctx) => ctx.spy(platformUtilAtom).is('browser-local'),
  'isBrowserLocalAtom',
)

export const isTauriOrBrowserLocalAtom = atom(
  (ctx) =>
    ctx.spy(platformUtilAtom).is('tauri') ||
    ctx.spy(platformUtilAtom).is('browser-local'),
  'isTauriOrBrowserLocalAtom',
)

export const isBrowserAtom = atom(
  (ctx) => ctx.spy(platformUtilAtom).is('browser'),
  'isBrowserAtom',
)
